module.exports = __webpack_public_path__ + "img/output_on.c185c566.svg";